import React, { useEffect, useState } from 'react';
import { Container, IconWrapper, RightContainer, TitleInput, Description, Link } from './styled';
import TitleIcon from '@mui/icons-material/ChromeReaderMode';
import { titleUpdate } from '../../../../Services/cardService';
import { useDispatch, useSelector } from 'react-redux';
import MembersFeature from '../Features/MembersFeature';

const Title = () => {
	const dispatch = useDispatch();
	const card = useSelector((state) => state.card);
	const [title, setTitle] = useState('');

	useEffect(() => {
		setTitle(card.title);
	}, [card.title]);

	const handleTitleAccept = async () => {
		await titleUpdate(card.cardId, card.listId, card.boardId, title, dispatch);
	};

	return (
		<Container>
			<IconWrapper>
				<TitleIcon fontSize='small' />
			</IconWrapper>
			<RightContainer>
			<div className='d-flex justify-content-between '>
			<div>
			<TitleInput className='text-capitalize'
					value={title}
					onChange={(e) => setTitle(e.target.value)}
					onBlur={handleTitleAccept}
				></TitleInput>
				<Description>
					in list <Link className='text-capitalize'>{card.listTitle}</Link>
				</Description>
			</div>
				<div className='d-flex align-items-center gap-2 flex-column  px-3'>
				<MembersFeature />
				</div>
			</div>
			</RightContainer>
		</Container>
	);
};

export default Title;
